import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getDrainSelector } from '../selectors'
import { setAddToTimeLine } from '../store/drain.actions'
import { DrainConstants } from '../store/drain.constants'
import { IDrainState } from '../store/drain.types'
import { addDrainItem } from '../../../timeline/store/timeline.actions'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { handleNemsisCodeError, getUpdatedProcedureStateWithNemsisCode } from '../../../../utilities/nemsisCode.util'

export function* saveDrain() {
  const drainStateWithDefaults: IDrainState = yield select(getDrainSelector)
  let drainState: IDrainState = {
    ...drainStateWithDefaults,
    drainDefaults: null,
  }

  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)

  if (!pcrID) {
    // todo: add to audit log
    return
  }

  try {
    drainState = getUpdatedProcedureStateWithNemsisCode({
      procedureState: drainState,
      actionField: (s) => s.action?.id,
      filter1Field: null,
      filter2Field: null,
      filter3Field: null,
      nemsisCodeOptions,
    })
  } catch (error: unknown) {
    drainState = handleNemsisCodeError(error, drainState)
  }

  const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
  if (pcrDoc.patient?.drainStateList && pcrDoc.patient?.drainStateList.length) {
    const index = pcrDoc.patient?.drainStateList?.findIndex((drain) => drain.key === drainState.key)
    if (index !== -1) {
      pcrDoc.patient.drainStateList[index] = drainState
    } else {
      pcrDoc.patient?.drainStateList.push(drainState)
    }
  } else {
    pcrDoc.patient = { ...pcrDoc.patient, drainStateList: [drainState] }
  }
  try {
    const pcrDocUpdated = { ...pcrDoc, patient: { ...pcrDoc.patient } }
    yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    yield put(setAddToTimeLine(true))
    yield put(addDrainItem())
  } catch (e) {
    yield put(throwPcrException(`saveDrain() error: ${e}`))
  }
}

export function* saveDrainSaga() {
  yield takeLatest([DrainConstants.SAVE_DRAIN, DrainConstants.SET_PTA], performWithMutexHOG, saveDrain)
}
